import { createAsyncAction, createAction } from "../../utils/redux";

export const loginAction = createAsyncAction("account/login");
export const logoutAction = createAction("account/logout");
